import { useLocation } from 'react-router-dom'

import { useFeatureValue } from '@growthbook/growthbook-react'

import type { MemberBenefitsInfo } from '../../../../generated/frontend'
import { useMemberBenefitsInfoQuery } from '../../../../generated/frontend'
import { LoggedOutMemberBenefits } from '../../../home/components/PersonalisedMemberBenefits/components/LoggedOut/LoggedOutMemberBenefits'
import styles from './ArticleMemberBenefits.module.scss'

function MemberBenefitsExperiment({
  memberBenefitsInfo,
}: {
  memberBenefitsInfo: MemberBenefitsInfo
}) {
  const featureEnabled = useFeatureValue('DSP-022-member-benefits-on-article-pages', false)

  return featureEnabled ? (
    <div className={styles.container}>
      <LoggedOutMemberBenefits
        creative={memberBenefitsInfo.creative.val}
        caption={memberBenefitsInfo.caption}
        overline={memberBenefitsInfo.overline}
        widgetLinks={memberBenefitsInfo.links}
        offerPrice={memberBenefitsInfo.offerPrice}
        previousOfferPrice={memberBenefitsInfo.previousOfferPrice}
        data-testid="logged-out-benefits-v2"
      />
    </div>
  ) : null
}

export function ArticleMemberBenefits() {
  const { data: { memberBenefitsInfo } = {}, loading } = useMemberBenefitsInfoQuery()

  const { search } = useLocation()
  const params = new URLSearchParams(search)

  if (
    params.get('utm_medium') !== 'cpc' ||
    loading === true ||
    memberBenefitsInfo === undefined ||
    memberBenefitsInfo.isLoggedIn === true
  ) {
    return null
  }

  return <MemberBenefitsExperiment memberBenefitsInfo={memberBenefitsInfo} />
}
